(() => {
  if (window.__cavadorFlooringGalleryInitialized) return;
  window.__cavadorFlooringGalleryInitialized = true;
  const selector = '.aurora-pdp[data-flooring-gallery]';
  const instances = new Map();

  const scrollAncestor = element => {
    for (let parent = element.parentElement; parent; parent = parent.parentElement) {
      if (/^(auto|scroll|overlay)$/.test(getComputedStyle(parent).overflowY)) return parent;
    }
    return null;
  };

  const setup = root => {
    if (instances.has(root)) return;
    const gallery = root.querySelector('.aurora-pdp__media');
    if (!gallery) return;
    const scrollport = scrollAncestor(gallery);
    const header = document.querySelector('.header-editorial');
    const desktop = matchMedia('(min-width: 990px)');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let frame = 0;
    let disposed = false;
    const measure = () => {
      frame = 0;
      if (disposed) return;
      if (!root.isConnected) { cleanup(); instances.delete(root); return; }
      if (!desktop.matches) {
        root.style.removeProperty('--flooring-gallery-top');
        return;
      }
      const viewportHeight = scrollport?.clientHeight || document.documentElement.clientHeight || window.innerHeight;
      const headerHeight = header?.offsetHeight || 0;
      const top = Math.min(headerHeight + 20, viewportHeight - gallery.offsetHeight - 20);
      root.style.setProperty('--flooring-gallery-top', `${top}px`);
    };
    const schedule = () => {
      if (!disposed && !frame) frame = requestAnimationFrame(measure);
    };
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    observer?.observe(gallery);
    if (header) observer?.observe(header);
    observer?.observe(scrollport || document.documentElement);
    window.addEventListener('resize', schedule, options);
    desktop.addEventListener('change', schedule, options);
    const cleanup = () => {
      if (disposed) return;
      disposed = true;
      controller.abort();
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      root.style.removeProperty('--flooring-gallery-top');
    };
    instances.set(root, cleanup);
    schedule();
  };

  const initialize = scope => {
    if (scope.matches?.(selector)) setup(scope);
    scope.querySelectorAll(selector).forEach(setup);
  };
  document.addEventListener('shopify:section:load', () => {
    instances.forEach(cleanup => cleanup());
    instances.clear();
    initialize(document);
  });
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (event.target === root || event.target.contains(root)) {
        cleanup();
        instances.delete(root);
      }
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
